import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

const container = document.getElementById('root');
if (container === null) throw new Error('#root introuvable');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Service worker: application shell cache plus the last snapshot, so the app opens
// in airplane mode. Registered after load so it never delays first paint.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // No service worker: the app still works, it just will not open offline.
    });
  });
}
